export const BREED_ID = 'breed_id';
export const LOCATION = 'location';

// FAQ Lists
export const BREEDER_VETTING_CRITERIA = [
  'Proper living conditions',
  'Health and well-being of breeding dogs',
  'Puppy health',
  'Socialization practices of puppies',
  'Health screening for hereditary disease',
  'Resources and support for new owners',
  'Comprehensive puppy policies and owner support'
];

export const CERTIFIED_BREEDER_PROCESS = [
  'Pass our rigorous screening protocol',
  'Adhere to our community standards',
  'Meet or exceed breed-specific health testing requirements',
  'Maintain transparency in their breeding practices',
  'Follow our Good Breeder Code of Ethics'
];

export const HEALTH_TEST_REQUIREMENT_SOURCES = [
  'Breed-specific health and hereditary concerns',
  'Current scientific research',
  'Breed club recommendations',
  'Expertise from reputable breeders'
];
